import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CHURCH_WHATSAPP } from "../lib/config";
import { Phone, MapPin, Info } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-black text-white py-16 px-6 lg:px-12 overflow-hidden">
      <div className="absolute inset-0 grain opacity-30" />
      <div className="relative max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-28 h-28 rounded-full bg-white p-2 shadow-2xl ring-2 ring-yellow-400/50 flex-shrink-0 overflow-hidden flex items-center justify-center">
                <img src="/logo.png" alt="" className="w-full h-full object-contain" loading="lazy" />
              </div>
              <div>
                <div className="font-heading text-2xl tracking-wider">CASA DE ORACIÓN</div>
                <div className="text-yellow-400 text-xs uppercase tracking-[0.3em]">Ven y Ve</div>
                <div className="text-white/40 text-[10px] uppercase tracking-widest">Iglesia del Nazareno</div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Primera Iglesia del Nazareno. Un hogar donde Dios te espera con los brazos abiertos.
            </p>
          </div>

          <div>
            <h4 className="font-heading uppercase text-yellow-400 text-lg mb-4 tracking-wider">Contacto</h4>
            <a
              href={`https://wa.me/${CHURCH_WHATSAPP}`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-3 text-white/80 hover:text-yellow-400 mb-3 transition-colors"
            >
              <Phone className="w-4 h-4" />
              614-508-0303
            </a>
            <div className="flex items-center gap-3 text-white/60">
              <MapPin className="w-4 h-4 mt-0.5" />
              <span className="text-sm">Primera Iglesia del Nazareno</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading uppercase text-yellow-400 text-lg mb-4 tracking-wider">El Evento</h4>
            <p className="text-white/80 text-sm mb-2">
              <span className="text-yellow-400 font-bold">Agosto 28, 2026</span>
            </p>
            <p className="text-white/60 text-sm">3-6 años: $55 · 7-11 años: $150 · 12+ años: $250</p>
            <p className="text-white/60 text-sm mt-2">
              Inscríbete con un plan de pago cómodo: diario, semanal, quincenal o mensual.
            </p>
            <Link
              to="/info"
              data-testid="footer-info-link"
              className="mt-4 inline-flex items-center gap-2 text-yellow-400 hover:text-yellow-300 text-sm font-bold uppercase tracking-widest"
            >
              <Info className="w-4 h-4" /> Info & Qué llevar
            </Link>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-16 pt-8 border-t border-white/10 text-center"
        >
          <div className="font-heading uppercase text-3xl sm:text-5xl text-gradient-gold tracking-tight mb-2">
            Operación Rescate 2026
          </div>
          <p className="text-white/40 text-xs uppercase tracking-widest">
            Un encuentro que puede cambiar tu vida
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
